<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <h2 class="">
            MarineAI: Elevate Your Business with Custom Generative AI
            SolutionsTailored AI Solutions for the Marine Industry
          </h2>

          <div class="pt-2 divpara">
            At MarineAI, we specialize in providing enterprise-grade Generative
            AI solutions that move beyond the risks of using generic public
            models. Our tailored approach empowers marine businesses to harness
            their unique data and knowledge, ensuring reliable, secure, and
            scalable AI-driven outcomes.
          </div>

          <div class="pt-3">
            <h3>Unlock the Power of Your Data</h3>
            <p>
              Our bespoke Generative AI solutions are designed to help you
              leverage your data in transformative ways, creating AI systems
              that fit your business's specific needs and deliver significant,
              measurable results.
            </p>
          </div>
          <div class="texv pt-4">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi mdi-pencil </v-icon>&nbsp;
              <span class="sicon"
                ><b>Tailored Models:</b> Our AI models are trained exclusively
                on your company data, ensuring relevant and actionable
                insights.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cloud</v-icon>&nbsp;
              <span class="sicon"
                ><b>Data-Driven Transformation:</b> Establish a solid data
                foundation to unlock your company’s potential through AI.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cogs</v-icon>&nbsp;
              <span class="sicon"
                ><b>Integrated Business Solutions:</b> Seamlessly integrate AI
                into your workflows, driving operational efficiency and
                growth.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-shield-check</v-icon>&nbsp;
              <span class="sicon"
                ><b>Trust & Security:</b> Built-in trust mechanisms and privacy
                protections ensure a safe and reliable AI deployment.</span
              >
            </div>
          </div>

          <div class="pt-3">
            <h3>Why Choose MarineAI?</h3>
            <p>
              We don’t just deliver AI solutions—we empower your business to
              transform and scale. MarineAI offers:
            </p>
          </div>

          <div class="texv">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-account-cog </v-icon>&nbsp;
              <span class="sicon"
                ><b>Industry Expertise:</b> Our experience in the marine sector
                ensures that our AI solutions are tailored to your industry’s
                needs.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-map-marker-path </v-icon>&nbsp;
              <span class="sicon"
                ><b>End-to-End Support:</b> From strategy to deployment, we
                guide you through the entire AI journey.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-robot </v-icon>&nbsp;
              <span class="sicon"
                ><b>Scalable AI:</b> Our solutions grow with your business,
                ensuring continuous innovation and adaptability.</span
              >
            </div>
          </div>

          <div class="pt-3">
            <h3>Key Features of MarineAI’s Generative AI Framework</h3>
          </div>
          <div class="texv pt-3">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-database </v-icon>&nbsp;
              <span class="sicon"
                ><b>Data Foundation:</b> Robust data platform designed to
                support AI model development.</span
              >
            </div>

            <div class="icon-container">
              <v-icon color="white" x-large> mdi-file-document </v-icon>&nbsp;
              <span class="sicon"
                ><b>Custom Model Training:</b> AI models fine-tuned to your
                specific business knowledge and processes.</span
              >
            </div>

            <div class="icon-container">
              <v-icon color="white" x-large> mdi-layers</v-icon>&nbsp;
              <span class="sicon"
                ><b>Business Integration:</b> Solutions seamlessly integrated
                into your business domains for real-world usage.</span
              >
            </div>

            <div class="icon-container">
              <v-icon color="white" x-large> mdi-bug-check </v-icon>&nbsp;
              <span class="sicon"
                ><b>Trust & Testing:</b> Rigorous testing and trust layers for
                secure and reliable AI deployment.</span
              >
            </div>
          </div>

          <div class="pt-3">
            <h3>How MarineAI Can Elevate Your Business</h3>
          </div>
          <div class="texv pt-4">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-wrench-cog </v-icon>&nbsp;
              <span class="sicon"
                ><b>Fine-Tuning Generative Models:</b> We optimize generative
                models for your business, ensuring they provide accurate and
                relevant outputs.</span
              >
            </div>

            <div class="icon-container">
              <v-icon color="white" x-large> mdi-lightbulb-on </v-icon>&nbsp;
              <span class="sicon"
                ><b>Enterprise-Ready Solutions:</b> From MVP development to
                enterprise-level deployment, we deliver solutions that scale as
                your business grows.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-shield </v-icon>&nbsp;
              <span class="sicon"
                ><b>Secure and Privacy-Compliant:</b> Our AI systems are built
                with data security and privacy in mind, providing peace of mind
                while driving innovation.</span
              >
            </div>
          </div>

          <div>
            <b>Start Your AI Journey Today!</b>
            <P>
              Ready to see how Custom Generative AI can transform your marine
              business? Contact MarineAI to schedule a consultation and explore
              how our trusted solutions can drive real-world results for your
              enterprise.
            </P>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  name: "IconBackgrounds",
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "MarineAI: Elevating Your Possible with Generative AI";
  }
};
</script>

<style scoped>
.img {
  min-height: 200px;
}
.divpara {
  text-align: justify;
}
h1 {
  font-size: 30px;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.v-icon {
  background-color: #1a237e; /* Background color for the icon */
  padding: 10px; /* Padding to make background bigger */
  border-radius: 50%; /* Makes the background circular */
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.sicon {
  margin-left: 10px;
  font-size: 18px;
}
</style>
